import { Component, OnInit, Input } from '@angular/core';
import { ModelType } from 'src/app/common';
import { setTimeout$ } from 'src/app/core/common';
import { FavoriteService } from 'src/app/services/favorite.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-favorite-list',
  templateUrl: './favorite-list.component.html',
  styleUrls: ['./favorite-list.component.scss']
})
export class FavoriteListComponent implements OnInit {

  constructor(private favoriteService: FavoriteService, private spinner: SpinnerService) { }

  @Input() type: ModelType;

  favorites: any[];
  total: number;

  async ngOnInit() {
    await this.load();
  }

  private async load() {
    this.spinner.show();
    const result = await this.favoriteService.search({ Type: this.type }, 0, 100);
    if (result) {
      this.favorites = result.favorites;
      this.total = result.total;
    }
    this.spinner.hide();
  }

  async remove(favorite: any, e?: MouseEvent | boolean) {
    this.spinner.show(favorite.Id);
    await this.favoriteService.toggle(favorite);
    setTimeout$(async () => {
      await this.load();
      this.spinner.hide(favorite.Id);
    }, 1000);
    return false;
  }
}
